import { Component } from "@angular/core";
import {
  ActivatedRoute,
  NavigationEnd,
  PRIMARY_OUTLET,
  Router,
} from "@angular/router";
import { filter, map } from "rxjs";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-breadcrumb",
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.scss"],
})
export class BreadcrumbComponent {
  public breadcrumbs: {
    subTitleLinkBreadcrumb?: string;
    subTitleBreadcrumb?: string;
    parentBreadcrumb?: string;
    childBreadcrumb?: string;
    enable?: boolean;
  };
  public title: string = "";
  protected env = environment;

  constructor(private readonly activatedRoute: ActivatedRoute, private readonly router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter((route) => route.outlet === PRIMARY_OUTLET))
      .subscribe((route) => {
        const snapshot = this.router.routerState.snapshot;
        let title = route.snapshot.data["title"];
        const parent = route.parent?.snapshot.data["breadcrumb"];
        const subTitle = route.snapshot.data["subTitle"];
        const subTitleLink = route.snapshot.data["subTitleLink"];
        const isEnable = route.parent?.snapshot.data["isEnable"];
        const child = route.snapshot.data["breadcrumb"];
        this.breadcrumbs = {};
        this.title = title;
        this.breadcrumbs = {
          subTitleLinkBreadcrumb: subTitleLink,
          subTitleBreadcrumb: subTitle,
          parentBreadcrumb: parent,
          childBreadcrumb: child,
          enable: isEnable,
        };
      });
  }
}
